export const getAllRiders = async (app) => {
  try {
    const mongo = app.currentUser.mongoClient("mongodb-atlas");
    const ridersCollection = mongo.db(process.env.REACT_APP_DB_NAME).collection("riders");
    const ridersData = await ridersCollection.find();
    return { ridersData };
  } catch (error) {
    console.error("Error fetching riders:", error);
  }
};

export function getRider(app, id) {
  const mongo = app.currentUser.mongoClient("mongodb-atlas");
  const ridersCollection = mongo.db(process.env.REACT_APP_DB_NAME).collection("riders");
  return ridersCollection.findOne({ _id: id });
}

export function getRiderByName(app, name) {
  const mongo = app.currentUser.mongoClient("mongodb-atlas");
  const ridersCollection = mongo.db(process.env.REACT_APP_DB_NAME).collection("riders");
  return ridersCollection.findOne({ name });
}

export function createRider(app, params) {
  const mongo = app.currentUser.mongoClient("mongodb-atlas");
  const ridersCollection = mongo.db(process.env.REACT_APP_DB_NAME).collection("riders");
  return ridersCollection.insertOne(params);
}
